import { Controller } from "@hotwired/stimulus"

// Custom-role matrix editor. Optional convenience: when the "based on"
// built-in role changes, prefill every area's radio to that role's level.
// The form still submits plain radios, so this is pure UX sugar — no JS is
// required for the editor to work.
export default class extends Controller {
	static targets = ["basedOnRole", "level"]
	static values = { presets: Object }

	applyPreset() {
		const role = this.basedOnRoleTarget.value
		const preset = this.presetsValue[role]
		if (!preset) return

		// Group radios by area, then select the one matching the preset level
		// ("" / null → the "none" radio).
		const areas = new Set(this.levelTargets.map((el) => el.dataset.area))
		for (const area of areas) {
			const wanted = preset[area]
			const wantedValue = wanted ? `${area}:${wanted}` : ""
			for (const radio of this.levelTargets) {
				if (radio.dataset.area !== area) continue
				radio.checked = radio.value === wantedValue
			}
		}
	}
}
